// @flow
import React, { type Element } from 'react';
import { compose, pure } from 'recompose';
import { reduxForm, Field, Form } from 'redux-form';
import { Track, validation } from 'angieslist-app-platform';
import { InputField } from 'angieslist-app-platform/lib/browser/forms';
import { Button } from 'angieslist-react-components';
import './reviewRetort.scss';

type Props = {
  text: string,
  reviewId: string,
  onCancel: () => void,
  // redux-form
  reset: () => void,
  handleSubmit: ((values: any) => void) => void,
  onSubmit: (values: any) => void,
  pristine: boolean,
  invalid: boolean,
}

const retortValidationRules = {
  text: {
    required: true,
    maxLength: 2048,
  },
  confirmation: {
    acceptance: true,
  },
};

const getCancelFn = (reset, onCancel) => () => {
  reset();
  onCancel();
};

export const ReviewRetortFormComponent = ({
  text, reviewId, pristine, invalid, reset, onCancel, onSubmit, handleSubmit,
}: Props): Element<"div"> => (
  <div style={{ marginTop: '1em' }}>
    <p><strong>Service Provider Response:</strong></p>
    <Form name="editRetort" onSubmit={handleSubmit(onSubmit)}>
      <Field
        name="text"
        id={`edit-retort--text--${reviewId}`}
        value={text}
        component={InputField}
        type="textarea"
        style={{ minHeight: 150 }}
      />
      <Field
        disabled={pristine}
        name="confirmation"
        id={`edit-retort--confirmation--${reviewId}`}
        component={InputField}
        type="checkbox"
        label="I confirm that the information contained in this response is true and
          accurate and represents my actual first-hand experience. I understand that
          Angi relies upon the accuracy of the information in order to service its
          members. I understand that Angi will attempt to fairly represent both
          sides of the issue. I also understand that my response will be reviewed and may
          be altered if I have used any name or have used language that Angi deems
          inappropriate."
      />
      <div className="pull-right">
        <Track>
          <Button
            type="submit"
            id={`edit-retort--save--${reviewId}`}
            bsSize="small"
            bsStyle="warning"
            disabled={pristine || invalid}
            data-track-review-id={reviewId}
          >
            <strong>SAVE</strong>
          </Button>
        </Track>
        <Track>
          <Button
            onClick={getCancelFn(reset, onCancel)}
            id={`edit-retort--cancel-editing--${reviewId}`}
            bsSize="small"
            bsStyle="default-office"
            style={{ marginLeft: 5 }}
            data-track-review-id={reviewId}
          >
            <strong>CANCEL</strong>
          </Button>
        </Track>
      </div>
    </Form>
  </div>
);

export default (compose(
  reduxForm({
    validate: values => validation.validate(values, retortValidationRules).invalidAttrs,
    destroyOnUnmount: false,
    enableReinitialize: true,
    forceUnregisterOnUnmount: false,
  }),
  pure,
)(ReviewRetortFormComponent): any);



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/reviews/ReviewRetortForm.js